// extracted by mini-css-extract-plugin
module.exports = {"axis":"AxisX_axis__39Uz7","line":"AxisX_line__39ZHo","tick":"AxisX_tick__1QmRx"};